import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../Context/ConfigContext';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishList, removeWishListItem } from '../Redux/features/WishList/WishlistSlice';
import { toast } from 'react-toastify';
import { addToCart } from '../Redux/features/Cart/CartSlice';
import { useTranslation } from 'react-i18next';
import { formatSlug } from '../Utils/Helper';
import GlobalCards from '../Utils/GlobalCards';
import { setRef } from '@mui/material';
import CardShimmer from '../Utils/shimmerEffect/CardShimmer'
import { formatPrice } from '../Utils/GlobalFunction';

const Trending = () => {

    const { apiURL, currency, apiHeaderJson, currencyValue } = useContext(ConfigContext);
    const [data, setData] = useState([]);
    const [expandedId, setExpandedId] = useState(null);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch()
    const wishList = useSelector(state => state.Wishlist)
    const { t } = useTranslation();
    const navigate = useNavigate()

    const GetProducts = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${apiURL}Home/GetTrendingProducts`, { headers: apiHeaderJson });
            setData(response.data.data);
            setLoading(false)
        } catch (err) {
            console.error(err)
        }
    };

    const CheckWishList = (product_id) => {
        return wishList.some((item) => item.product_id === product_id);
    }

    const toggleExpansion = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const handleAddToCart = (product) => {
        const newProduct = { ...product, selected_currency: currencyValue }
        dispatch(addToCart(newProduct))
        toast.success(`${product.product_title} Added`, {
            position: "bottom-center",
        })
    }

    const handleAddToWishList = (item) => {
        const newProduct = { ...item, selected_currency: currencyValue }
        dispatch(addToWishList(newProduct))
    }

    const handleProductDetails = (product) => {
        if (product) {
            navigate(`/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`)
        }
    }

    const getStarPercent = (rating) => {
        return (rating / 5) * 100;
    };

    useEffect(() => {
        GetProducts();
    }, []);

    return (
        <>
            {
                data.length === 0 ? " " :
                    <section className="section-padding pb-5 mb-3">
                        <div className="container">
                            <div className="section-title wow animate__animated animate__fadeIn mb-3">
                                <h3>Trending Products</h3>
                                <ul className="nav nav-tabs links" id="myTab-2" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="nav-tab-two-1" data-bs-toggle="tab" data-bs-target="#tab-two-1" type="button" role="tab" aria-controls="tab-two" aria-selected="false">Trending Products</button>
                                    </li>
                                </ul>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 d-none d-lg-flex wow animate__animated animate__fadeIn">
                                    <div className="banner-img style-2">
                                        <div className="banner-text">
                                            <h2 className="mb-20 text-white">Stones that will flourish the beauty of our homes</h2>
                                            <Link to="/AllProductsList" className="btn btn-xs">Shop Now <i className="fi-rs-arrow-small-right" /></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-12 wow animate__animated animate__fadeIn" data-wow-delay=".4s">
                                    <div className="tab-content" id="myTabContent-1">
                                        <div className="tab-pane fade show active" id="tab-one-1" role="tabpanel" aria-labelledby="tab-one-1">
                                            <div className="carausel-4-columns-cover arrow-center position-relative">
                                                <div className="slider-arrow slider-arrow-2 carausel-4-columns-arrow" id="carausel-4-columns-arrows" />
                                                <div className="carausel-4-columns carausel-arrow-center" id="carausel-4-columns">
                                                    {loading
                                                        ? Array.from({ length: 5 }).map((_, i) => <CardShimmer key={i} />)
                                                        : data.map((item, i) => {
                                                            return (
                                                                <div key={item.product_id} className="product-cart-wrap">
                                                                    <div className="product-img-action-wrap">
                                                                        <div className="product-img product-img-zoom">
                                                                            <a>
                                                                                <img
                                                                                    onClick={() => handleProductDetails(item)}
                                                                                    className="default-img"
                                                                                    loading='lazy'
                                                                                    src={item.product_image_url}
                                                                                    alt={item?.product_title}
                                                                                />
                                                                            </a>
                                                                        </div>
                                                                        <div className="product-action-1">
                                                                            {
                                                                                CheckWishList(item.product_id) === true ?
                                                                                    (
                                                                                        <a
                                                                                            onClick={() => dispatch(removeWishListItem(item.product_id))}
                                                                                            aria-label={`Remove From Wishlist`}
                                                                                            className="action-btn"
                                                                                            style={{ background: '#FDC040' }}
                                                                                        >
                                                                                            <i style={{ color: '#fff' }}
                                                                                                className="fi-rs-heart" />
                                                                                        </a>
                                                                                    )
                                                                                    :
                                                                                    (
                                                                                        <a
                                                                                            onClick={() => handleAddToWishList(item)}
                                                                                            aria-label={`Add To Wishlist`}
                                                                                            className="action-btn" >
                                                                                            <i className="fi-rs-heart" />
                                                                                        </a>
                                                                                    )
                                                                            }
                                                                        </div>
                                                                        {item?.product_label === "New" ? (
                                                                            <div className="product-badges product-badges-position product-badges-mrg">
                                                                                <span className={item.product_label_class}>{item.product_label}</span>
                                                                            </div>
                                                                        )
                                                                            : ""}
                                                                    </div>
                                                                    <div className="product-content-wrap">
                                                                        <h2 onClick={() => handleProductDetails(item)}><a style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}> {item.product_title}</a></h2>
                                                                        {item.average_rating === "0" ? "" :
                                                                            <>
                                                                                <div className="product-rate d-inline-block">
                                                                                    <div className="product-rating" style={{ width: getStarPercent(item?.average_rating) + '%' }} />
                                                                                </div>
                                                                                <span className="font-small ml-5 text-muted">{item.average_rating}</span>
                                                                            </>
                                                                        }
                                                                        <div className="product-price mt-10">
                                                                            <div className="product-price">
                                                                                {item.product_stock_status !== 0 ? (
                                                                                    <>
                                                                                        <span>{formatPrice(item.product_variant_sale_price, item.selected_currency)}</span>
                                                                                        <span className="old-price">{formatPrice(item.product_variant_mrp_price, item.selected_currency)}</span>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="product-price" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "25px" }}>
                                                                                    </div>

                                                                                )}
                                                                            </div>

                                                                        </div>
                                                                        <span
                                                                            onClick={() => {
                                                                                if (item.product_stock_status !== 0) {
                                                                                    handleAddToCart(item);
                                                                                }
                                                                            }}

                                                                            className={`btn w-100 hover-up mt-15 ${item.product_stock_status === 0 ? 'disabled' : ''}`}
                                                                            style={item.product_stock_status === 0 ? { backgroundColor: '#ccc', cursor: 'not-allowed' } : {}}
                                                                        >
                                                                            <i className="fi-rs-shopping-cart mr-5" />
                                                                            {item.product_stock_status === 0 ? "Out Stock" : "Add To Cart"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section >
            }
        </>
    )
}

export default Trending